import {delay, texture, json, padNum} from "p3";
import { Emitter } from "pixi-particles";
import common from "../../../common";
import definitions from "../../../definitions";
import Item from "./Item";
import GameScene from "../../../scenes/GameScene";
import ItemGoldenCoin from "./ItemGoldenButton";
import settings from "../../../settings";

export default class ItemTreasure extends Item {
    constructor(properties) {
        super(definitions.ITEM_ID.TREASURE, texture("prop_treasure_chest_00"));

        this._properties = properties;
        this._instance = null;
        this._opened = false;
        this._coinAmount = 100;
        this.interactable = false;

        this._spinningCoins = [];

        this._fx = null;
        this._coinBurst = null;
    }

    init() {
        super.init();

        ////console.log('TREASURE', this._properties);

        for (let i in this._properties) {
            if (this._properties[i].name == 'instance') {
                this._instance = this._properties[i].value;
            }
        }
        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 0.6, new PIXI.Point(0, 0));

        this._emitFx();
    }

    update() {
        this._fx && this._fx.update(window.dt);
        this._coinBurst && this._coinBurst.update(window.dt);

        for (let i = 0; i < this._spinningCoins.length; i++) {
            this._spinningCoins[i] && this._spinningCoins[i].update(window.dt);
        }

        super.update();
    }

    _emitFx() {
        this._fx = this._createFx("fx_treasure_chest_attract", [texture("path_tile_sparkle_attract_fx_00"), texture("path_tile_sparkle_attract_fx_01")]);
    }

    _createFx(emitterJson, textures=[]) {
        const emitter = new Emitter(this, textures, json(emitterJson));
        emitter.autoUpdate = false;
        emitter.updateSpawnPos(0, -40);
        return emitter;
    }

    animateFloat() {
        super.animateFloat();
        this.stopAnimations();
        this._view.anchor.y = 1;
    }

    spawn() {
        ////console.log('Treasure spawn', common.saveData.activeSlot.treasures, this._instance, common.saveData.activeSlot.treasures.indexOf(this._instance));
        if (this._instance != null && common.saveData.activeSlot.treasures.indexOf(this._instance) >= 0) {
            this._opened = true;
            this.setTextureAsOpened();
        }
        super.spawn();
    }

    setTextureAsOpened(){
        this._texture = texture("prop_treasure_chest_01");
        this._view.texture = this._texture;
    }

    collect() {
        if (this._opened) {
            return false;
        }
        if (this._instance != null && common.saveData.activeSlot.treasures.indexOf(this._instance) < 0) {
            common.saveData.activeSlot.treasures.push(this._instance);
            common.saveData.saveGame();
        }
        this._opened = true;

        P3.audio.playSound("music_chest_opening_good");
        const tl = new gsap.timeline({onComplete:() => {
            this._view.scale.y = 1;
            this.setTextureAsOpened();

            this._coinBurst = this._createFx("fx_burst", [
                texture("button_sparkle_attract_fx_00"), 
                texture("button_sparkle_attract_fx_01")
            ]);

            const max = Math.min(25, this._coinAmount);

            for (let i = 0; i < max; i++) {
                let frames = [];

                for (let i = 0; i < 6; ++i) { 
                    frames[i] = texture("prop_gold_coin_" + padNum(i+1, 2)); 
                }

                const sequence = new P3.MovieClipSequence(frames, "idle");

                this._spinningCoins[i] = new P3.MovieClip(sequence, "idle", false);
                this._spinningCoins[i].anchor.set(0.5);
                this.addChild(this._spinningCoins[i]);
                this._spinningCoins[i].animationSpeed = 10;

                delay(i * 0.01, () => {
                    this._spinningCoins[i].gotoAndPlay("idle", true);
                });
        
                const position = GameScene.active.world.findSafePosition({x:this._view.x, y:this._view.y}, 150, 80, 20, [], 10);

                GameScene.active.addTween(
                    gsap.to(this._spinningCoins[i], 0.5, {ease:Expo.easeInOut, motionPath: {
                        path: [
                            {x:0, y:-20}, 
                            {x:position.x/2, y:-100}, 
                            {x:position.x, y:position.y}
                        ]
                    }})
                );
            }

            delay(1.0, () => {
                for (let j = 0; j < this._spinningCoins.length; ++j) {
                    const target = settings.PHASE > 1 ? GameScene.active.hud.coinHolder : GameScene.active.hud.inventoryButton;

                    let chestHudCoords = target.toLocal(new PIXI.Point(this._spinningCoins[j].x, this._spinningCoins[j].y), this._spinningCoins[j].parent);
    
                    let coin = new PIXI.Sprite(texture('prop_gold_coin_01'));
                    coin.anchor.set(0.5);
                    coin.x = chestHudCoords.x;
                    coin.y = chestHudCoords.y - 100;
                    coin.visible = false;
                    coin.scale.set(1.3);
                    target.addChild(coin);

                    GameScene.active.addTween(
                        gsap.to(coin.scale, 0.25, {delay:j * 0.05, x: 1, y: 1, ease:Power0.easeIn})
                    );
                    GameScene.active.addTween(
                        gsap.to(coin, 0.5, {delay:j * 0.05, x: -60, y: 0, ease:Expo.easeOut, onStart:() => {                  
                            this._spinningCoins[j].visible = false;
                            P3.audio.playSound("sfx_pickup_coins");
                            coin.visible = true;
                            if (this.onUpdate) {
                                this.onUpdate((j+1) / max);
                            }
                        }, onComplete:() => {
                            coin.visible = false;

                            if (GameScene.active.hud.coinHolder) {
                                GameScene.active.hud.coinHolder.coinAmount += 4;
                            }
                        }})
                    );
                }
            });  

            //this._view.addChild(new CoinAnimation(this._coinAmount, GameScene.active));

            common.saveData.activeSlot.coins += this._coinAmount;
            common.saveData.saveGame();
        }});
        GameScene.active.addTween(tl);
        tl.to(this._view.scale, 0.2, {y:0.6, ease:Sine.easeIn});
        tl.to(this._view.scale, 0.1, {y:0.7, ease:Sine.easeInOut, repeat:7, yoyo:true});
        tl.to(this._view.scale, 0.1, {y:0.9, ease:Sine.easeInOut, repeat:7, yoyo:true});

        this._fx.destroy();

        return false;
    }
}